'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n  font-family: \'Nunito Sans\';\n  margin: 0px;\n'], ['\n  ', '\n  ', '\n  ', '\n  font-family: \'Nunito Sans\';\n  margin: 0px;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _colors = require('../../../behaviors/colors');
var _fontSize = require('../../../behaviors/fontSize');
var _fontWeight = require('../../../behaviors/fontWeight');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TAG = function TAG(props) {
  return _react2.default.createElement(props.tag, props);
};
exports.default = (0, _styledComponents2.default)(TAG)(_templateObject, _colors.withTextColor, _fontSize.withTextSize, _fontWeight.withTextWeight);